<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <template v-slot:header>
            <div class="pull-left mt-2 mb-2"><strong>{{ header }}</strong></div>
            <b-button
              v-if="filters && filters.length"
              size="sm"
              variant="secondary"
              class="pull-right mt-1"
              @click="resetFilters"
            >Reset filters
            </b-button
            >
            <resource-actions :actions="actions" :endpoint="endpoint"/>
          </template>
          <resource-filters
            v-model="filters"
            v-if="filters && filters.length"
            :disabled="busy"
            class="mb-3"
          />
          <resource-table
            :endpoint="endpoint"
            :show-route="showRoute"
            v-model="filters"
            @inputActions="actions = $event"
            @onBusy="handleBusy"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import ResourceFilters from './ResourceFilters';
  import ResourceTable from './ResourceTable';
  import ResourceActions from "./ResourceActions";

  let timer = null;

  export default {
    props: {endpoint: {}, showRoute: {}, header: {}},
    components: {ResourceActions, ResourceTable, ResourceFilters},
    methods: {
      handleBusy(state) {
        console.log('handleBusy', state);
        this.busy = state;
      },
      resetFilters() {
        this.filters.forEach((item, index) => {
          this.filters[index].value = null;
        });
      },
      storeFilters(value) {
        if (timer) clearTimeout(timer);

        timer = setTimeout(() => {
          const namespace = this.endpoint;

          localStorage.setItem(`${namespace}-filters`, JSON.stringify(value));
        }, 500);
      },
      autoLoadFilters() {
        const namespace = this.endpoint;

        const filters = localStorage.getItem(`${namespace}-filters`);

        if (filters) {
          this.filters = JSON.parse(filters);
        }
      },
    },
    data() {
      return {
        filters: [],
        actions: [],
        busy: false,
      };
    },
    beforeMount() {
      this.autoLoadFilters();
    },
    watch: {
      filters: {
        handler(oldValue, newValue) {
          this.storeFilters(newValue);
        },
        deep: true,
      },
    },
  };
</script>
